"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
// [STOMP Frame](http://stomp.github.com/stomp-specification-1.1.html#STOMP_Frames) Class
var Frame = /** @class */ (function () {
    // Frame constructor
    function Frame(command, headers, body) {
        if (headers === void 0) { headers = {}; }
        if (body === void 0) { body = ''; }
        var _this = this;
        // Provides a textual representation of the frame
        // suitable to be sent to the server
        this.toString = function () {
            var lines = [_this.command], skipContentLength = _this.headers['content-length'] === false;
            if (skipContentLength)
                delete _this.headers['content-length'];
            Object.keys(_this.headers).forEach(function (name) {
                var value = _this.headers[name];
                lines.push(name + ":" + value);
            });
            if (_this.body && !skipContentLength) {
                lines.push("content-length:" + utils_1.sizeOfUTF8(_this.body));
            }
            lines.push(utils_1.BYTES.LF + _this.body);
            return lines.join(utils_1.BYTES.LF);
        };
        this.command = command;
        this.headers = headers;
        this.body = body;
    }
    // Unmarshall a single STOMP frame from a `data` string
    Frame.unmarshallSingle = function (data) {
        // search for 2 consecutives LF byte to split the command
        // and headers from the body
        var divider = data.search(new RegExp(utils_1.BYTES.LF + utils_1.BYTES.LF)), headerLines = data.substring(0, divider).split(utils_1.BYTES.LF), command = headerLines.shift(), headers = {}, body = '', 
        // skip the 2 LF bytes that divides the headers from the body
        bodyIndex = divider + 2;
        // Parse headers in reverse order so that for repeated headers, the 1st
        // value is used
        for (var _i = 0, _a = headerLines.reverse(); _i < _a.length; _i++) {
            var line = _a[_i];
            var idx = line.indexOf(':');
            headers[utils_1.trim(line.substring(0, idx))] = utils_1.trim(line.substring(idx + 1));
        }
        // Parse body
        // check for content-length or topping at the first NULL byte found.
        if (headers['content-length']) {
            var len = parseInt(headers['content-length'], 10);
            body = ('' + data).substring(bodyIndex, bodyIndex + len);
        }
        else {
            var chr = null;
            for (var i = bodyIndex; i < data.length; i++) {
                chr = data.charAt(i);
                if (chr === utils_1.BYTES.NULL)
                    break;
                body += chr;
            }
        }
        return new Frame(command, headers, body);
    };
    // Split the data before unmarshalling every single STOMP frame.
    // Web socket servers can send multiple frames in a single websocket message.
    // If the message size exceeds the websocket message size, then a single
    // frame can be fragmented across multiple messages.
    //
    // `datas` is a string.
    //
    // returns an *array* of Frame objects
    Frame.unmarshall = function (datas) {
        // split and unmarshall *multiple STOMP frames* contained in a *single WebSocket frame*.
        // The data is split when a NULL byte (followed by zero or many LF bytes) is found
        var frames = datas.split(new RegExp(utils_1.BYTES.NULL + utils_1.BYTES.LF + '*')), firstFrames = frames.slice(0, -1), lastFrame = frames.slice(-1)[0], r = {
            frames: firstFrames.map(function (f) { return Frame.unmarshallSingle(f); }),
            partial: ''
        };
        // If this contains a final full message or just a acknowledgement of a PING
        // without any other content, process this frame, otherwise return the
        // contents of the buffer to the caller.
        if (lastFrame === utils_1.BYTES.LF || (lastFrame.search(RegExp(utils_1.BYTES.NULL + utils_1.BYTES.LF + '*$'))) !== -1) {
            r.frames.push(Frame.unmarshallSingle(lastFrame));
        }
        else {
            r.partial = lastFrame;
        }
        return r;
    };
    // Marshall a Stomp frame
    Frame.marshall = function (command, headers, body) {
        var frame = new Frame(command, headers, body);
        return frame.toString() + utils_1.BYTES.NULL;
    };
    return Frame;
}());
exports.default = Frame;
